import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';

@Component({
  selector: 'app-parking-lot-v1',
  templateUrl: './parking-lot-v1.component.html',
  styleUrls: ['./parking-lot-v1.component.scss'],
})
export class ParkingLotV1Component {
  @ViewChild('menu', { static: false }) menuRef!: ElementRef;
  isClicked: boolean = false;
  presentComponent: number = 2;
  features = [
    'Comprehensive analytics and reporting for lot managers',
    'Add daily & monthly parking option to your lot',
    'Realtime lot inventory of any truck on your lot',
    'Advertise your lot to millions of truck drivers',
  ];
  clickMenu(event: Event) {
    event.stopPropagation();
    this.isClicked = !this.isClicked;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const clickedInside = this.menuRef?.nativeElement?.contains(event.target);
    if (!clickedInside) {
      this.isClicked = false;
    }
  }
}
